import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Router } from "@angular/router";

import { NzModalService } from "ng-zorro-antd/modal";
import { User } from "src/app/shared/model/user.model";
import { PermissionService } from "src/app/shared/services/permissions.service";
import { UserSettingsService } from "src/app/shared/services/user-setting.service";

interface Roles {
  access: Access[];
  name: string;
  component: string;
  fields: string;
  id: number;
  icon: null | string;
  link: string;
  admin: number;
  Enabled: number;
  order?: number;
}

interface Access {
  name: string;
  read: boolean;
  write: boolean;
  edit?: boolean;
}

@Component({
  selector: "app-header-user",
  templateUrl: "./header-user.component.html",
  styleUrls: ["./header-user.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderUserComponent {
  user: User;
  views: any = [];
  isVisibleModal: boolean;
  showFilesModal: boolean = false;
  showChangePasswordModal: boolean = false;
  ssn: string = "";
  showEzFiles: boolean = false;
  loading: boolean = false;
  canView: boolean = false;
  isVisibleModalUpdateData: boolean;
  isDrawerVisible: boolean;
  constructor(
    private router: Router,
    private modalService: NzModalService,
    private userService: UserSettingsService,
    private permissionService: PermissionService
  ) {
    this.user = this.userService.getUser();

    this.views = [
      {
        title: "Dashboard",
        url: "/pages/dashboard",
        icon: "table",
        link: "lead",
        component: "DashboardComponent",
        name: "Dashboard",
      },
      {
        title: "Leads",
        url: "/pages/lead",
        icon: "table",
        link: "lead",
        component: "LeadComponent",
        name: "Lead",
      },
    ];
  }

  logout() {
    const modal = this.modalService.confirm({
      nzTitle: "Confirm",
      nzContent: "Are you sure you want to exit?",
      nzOkText: "OK",
      nzCancelText: "Cancel",
      nzOnCancel: () => {
        modal.close(false);
      },
      nzOnOk: () => {
        this.userService.logOut();
      },
    });
    modal.afterClose.subscribe((r) => {});
  }

  goToLink(url: string) {
    window.open(url, "_blank");
  }

  showModal() {
    this.isVisibleModal = true;
  }

  cancel() {
    this.showEzFiles = false;
    this.ssn = "";
    this.showFilesModal = false;
    this.loading = false;
  }

  openFilesModal() {
    this.showFilesModal = true;
  }

  openDrawer() {
    this.isDrawerVisible = true;
  }

  closeDrawer() {
    this.isDrawerVisible = false;
  }

  goTo(page: string) {
    this.closeDrawer();
    switch (page) {
      case "roles":
        this.router.navigate(["/pages/roles"]);
        break;
      case "users":
        this.router.navigate(["/pages/users"]);
        break;
      case "object-manager":
        this.router.navigate(["/pages/object-manager"]);
        break;
      case "list-of-val":
        this.router.navigate(["/pages/list-of-val"]);
        break;
      default:
        this.router.navigate(["/pages/dashboard"]);
        break;
    }
  }

  getInitials(): string {
    if (!this.user) return "";
    const { firstName, lastName } = this.user;
    return `${firstName?.charAt(0) ?? ""}${
      lastName?.charAt(0) ?? ""
    }`.toUpperCase();
  }

  get hasPermissionToConfig() {
    return this.permissionService.hasPermission("view_config_menu_options");
  }
}
